import StorageManager from "./StorageManager";
import AppManager from "./AppManager";
import ApiManager from "./api/ApiManager";
import ConfigManager from "./config/ConfigManager";
import NavigationManager from "./navigation/NavigationManager";
import UserManager from "./user/UserManager";
import FileManager from "./FileManager";
import InteractionManager from "./InteractionManager";
import StorageDataManager from "./StorageDataManager";
import UiManager from "./UiManager";
import ViewManager from "./view/ViewManager";
import PostManager from "./post/PostManager";
import LocationManager from "../../module/osm/location/LocationManager";
import GeneralManager from "./GeneralManager";

export interface IManager
{
    app: AppManager;
    api: ApiManager;
    config: ConfigManager;
    navigation: NavigationManager;
    storage: StorageManager;
    storageData: StorageDataManager;
    user: UserManager;
    post: PostManager;
    file: FileManager;
    general: GeneralManager;
    interaction: InteractionManager;
    location: LocationManager;
    ui: UiManager;
    view: ViewManager;
}

class Manager
{
    app: AppManager;
    api: ApiManager;
    config: ConfigManager;
    navigation: NavigationManager;
    storage: StorageManager;
    storageData: StorageDataManager;
    user: UserManager;
    post: PostManager;
    file: FileManager;
    general: GeneralManager;
    interaction: InteractionManager;
    location: LocationManager;
    ui: UiManager;
    view: ViewManager;

    constructor(props:IManager)
    {
        this.app = props.app;
        this.api = props.api;
        this.config = props.config;
        this.navigation = props.navigation;
        this.storage = props.storage;
        this.storageData = props.storageData;
        this.user = props.user;
        this.post = props.post;
        this.file = props.file;
        this.general = props.general;
        this.interaction = props.interaction;
        this.location = props.location;
        this.ui = props.ui;
        this.view = props.view;
    }
}

let manager:Manager|null = null;

export const createManager = (props: IManager): Manager =>
{
    manager = new Manager(props);
    return manager
}

export const getManager = (): Manager =>
{
    return manager!;
}